import React from 'react';
import { findArray } from 'helpers/utils'
import SportCode from "components/common/SportCode"
import { Card } from "react-bootstrap";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export default function ProgressionRule({ data, data2, filter, itemData = 'value', className = 'p-2 mt-1 mb-3' }) {
  const { mirs_discipline } = useUrlFriendlyToParameters()

  let dataNode = (data?.extendedConfig)
    ? data.extendedConfig
    : data
  let qualRule = data && findArray(dataNode, filter)[itemData];

  let dataNode2 = (data2?.extendedConfig)
    ? data2.extendedConfig
    : data2
  let qualRule2 = data2 && findArray(dataNode2, filter)[itemData];
  if(mirs_discipline === 'WRU') qualRule = 'UT2|34^SF|PP'
  return (
    (qualRule || qualRule2) &&
    <Card className={`qualification-rule ${className}`} >
      {qualRule && <SportCode code={qualRule} discipline={mirs_discipline} entity="@QualRule" disableLegend={true} />}
      {qualRule && qualRule2 && <br />}
      {qualRule2 && <SportCode code={qualRule2} discipline={mirs_discipline} entity="@QualRule" disableLegend={true} />}
    </Card>
  )
}

